$(document).ready(function () {
  $("ul.droplink").on("click", ".init", function () {
    $(this).closest("ul.droplink").find('ul').toggle();
  });

  var allOptions = $("ul.droplink").children("li:not(.init)");
  $("ul.droplink").on("click", "li:not(.init)", function () {
    allOptions.removeClass("selected");
    $(this).addClass("selected");
    $("ul.droplink").children(".init").html($(this).html());
    $(".button_redirect a").removeClass("btn-disabled").attr('href',$(this).attr('data-link'));
    $("ul.droplink").find('ul').toggle();
  });
});

$(document).on('click','.more-button',function() {
  $(this).parents('.expandable_content_wrapper').find('.content-description').hide();
  $(this).parents('.expandable_content_wrapper').find('.moretext').show();
});

$(document).on('click','.less-button',function() {
  $(this).parents('.expandable_content_wrapper').find('.moretext').hide();
  $(this).parents('.expandable_content_wrapper').find('.content-description').show();
  $('html, body').animate({
    scrollTop: $(".expandable_content_wrapper").offset().top - 150
  }, 500);
});

$(document).on('click','.droptotext_Content .text_with_drop .droplink ul li',function() {
  var data_dropdown = $(this).attr('data-dropdown');
  $(this).parents('.droptotext_Content').find('.dropdown_content_inner .descriptive_text').addClass('hidden');
  $(this).parents('.droptotext_Content').find('.dropdown_content_inner .descriptive_text[data-dropdown_content="'+data_dropdown+'"]').removeClass('hidden');
});

// CWI NK
$(document).on('click','.multi_tabs_block_section .multi_tabs_block_main .tab_title',function(){
  var data_title = $(this).attr('data_title');  
  $(this).parents('.multi_tabs_block_main').find('.single_tab_data_main').addClass('hidden');
  $(this).parents('.multi_tabs_block_main').find('.single_tab_data_main[data_title="'+data_title+'"]').removeClass('hidden');
  $('.cource_faq_section').parents('.shopify-section').addClass('hidden');
  $('.cource_faq_section.' + $(this).attr('for-faq')).parents('.shopify-section').removeClass('hidden');
});

$(document).ready(function(){
  $('.multi_tabs_block_section .multi_tabs_block_main .tab_title.default_open').click();
});

// if($('.infinite_slide_change .logos__slider__outer .logos__slider .logos__slide').length){
//   $('.infinite_slide_change .logos__slider__outer .logos__slider').each(function(currentIndex,elem){
//     setInterval(function(){
//       $(elem).find('.logos__slide').eq(currentIndex).click();
//       currentIndex = currentIndex + 1;
//       if(currentIndex >= $(elem).find('.logos__slide').length){
//         currentIndex = 0;
//       }
//     }, 2500);
//   });
// }

// CWI CODE A
$('.accordion-section collapsible-elements .accordion .accordion__title.default_trigger_click').click();